module.exports = __webpack_public_path__ + "img/appstore.8dd66176.svg";